import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Back from "assets/images/svg/back_blue.svg";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { client } from "helpers/client";
import { toast } from "react-toastify";
import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";

const CancelSubscription = ({ show, onHide,addon }) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient()
  const addonSubscriptionId = searchParams.get("addonSubscriptionId");
  const { t } = useTranslation("browse-apps");

  const [Count, SetCount] = useState(0);
  const {
    register,
    handleSubmit
  } = useForm();

  async function handleRequestRefund(data) {
    const requestRefundDto = {
      reason: data.reason,
      versionSubscriptionId: id
    };
    const { response } = await client("/customerProduct/refundRequestSubscription", { data: requestRefundDto });
    if (response) {
      onHide();
      queryClient.invalidateQueries(['subscription'])
      return toast.success(t('common:form.canceled'));
    }
  }

  async function handleRequestRefundAddon(data) {
    const requestRefundDto = {
      reason: data.reason,
      addonSubscriptionId: addonSubscriptionId
    };
    const { response } = await client("/CustomerProduct/CancelAddonSubscription", { data: requestRefundDto });
    if (response) {
      onHide();
      queryClient.invalidateQueries(['addon-details'])
      return toast.success(t('common:form.canceled'));
    }
  }

  return (
    <div>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={() => {
          onHide();
          SetCount(0);
        }}
        className="all-modal cancelSubscription"
      >
        <Modal.Body>
          <div className="header">
            <img src={Back} alt="back" onClick={onHide} />
            <h1> {t("myProducts.managePage.cancelSubscription")}</h1>
          </div>
          <form onSubmit={addon ? handleSubmit(handleRequestRefundAddon) : handleSubmit(handleRequestRefund)} className="row">
            <div className="col-md-12">
              <label className="div-textarea">
                <div className="header">
                  <span className="title">{t("myProducts.managePage.reasonForCancelation")}:</span>
                  <span className="count">{Count}/500</span>
                </div>
                <textarea
                  {...register("reason", { required: true })}
                  maxLength={500}
                  onChange={(e) => SetCount(e.target.value.length)}
                ></textarea>
              </label>
              <p className="content-info">
                ● {t("myProducts.managePage.haveTrouble")}? <Link to="/tickets">{t("myProducts.managePage.getHelp")}</Link>
              </p>
            </div>
            <div className="col-12">
              <button className="btn-White">{t("myProducts.managePage.cancelSubscription")}</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CancelSubscription;
